
<div
  class="field-item"
  :class="{
    'field-item--disabled': disabled,
    'field-item--dragging': isDragging
  }"
  draggable="true"
  @click="handleClick"
  @dragstart="handleDragStart"
  @dragend="handleDragEnd"
>
  <!-- Field Icon -->
  <div class="field-item__icon">
    <v-icon
      :color="fieldIconColor"
      size="20"
    >
      {{ fieldIcon }}
    </v-icon>
  </div>

  <!-- Field Info -->
  <div class="field-item__info">
    <div class="field-item__name">
      {{ field.displayName }}
    </div>
    <div class="field-item__path">
      {{ field.fieldName }}
    </div>
  </div>

  <!-- Field Metadata -->
  <div class="field-item__metadata">
    <!-- Used indicator -->
    <div v-if="isUsed" class="field-item__used-indicator">
      <v-icon
        :color="usageIndicatorColor"
        size="16"
        class="mr-1"
      >
        mdi-check-circle
      </v-icon>
      <span v-if="usageCount > 1" class="field-item__usage-count">
        {{ usageCount }}
      </span>
    </div>
    
    <!-- Field Flags -->
    <div class="field-item__flags">
      <!-- Incremental field indicator removed as requested -->
    </div>
  </div>
</div>
